import { Canvas, extend, useFrame, useLoader } from '@react-three/fiber';
import {
    useGLTF,
    Line,
    Effects,
    PerspectiveCamera,
    Stars,
    OrbitControls,
    Points,
    Point,
    PointMaterial,
} from '@react-three/drei';
import { TextureLoader } from 'three/src/loaders/TextureLoader';
import { UnrealBloomPass } from 'three-stdlib';
import {
    EffectComposer,
    N8AO,
    Bloom,
    Noise,
    Vignette,
} from '@react-three/postprocessing';
import { MathUtils } from 'three';
import { useRef, useMemo, useState } from 'react';
import { useControls } from 'leva';
import * as THREE from 'three';

import Moon from '../../components/moon/Moon';
import MoonRing from '../../components/moon/MoonRing';
import Sun from '../../components/sun/Sun';
import SunFlash from '../../components/sun/SunFlash';

extend({ UnrealBloomPass });

function toRadians(angle) {
    return angle * (Math.PI / 180);
}

const Amb = () => {
    const ref = useRef();

    return <>{/* <ambientLight intensity={0.2} color={'#333'} /> */}</>;
};

const HomeScene = () => {
    // const { threshold, intensity, radius, red, green, blue } = useControls({
    // 	intensity: { value: 0.8, min: 0, max: 10, step: 0.01 },
    // 	radius: { value: 2.2, min: 0, max: 40, step: 0.01 },
    // 	red: { value: 0, min: 0, max: 50, step: 0.01 },
    // 	green: { value: 30, min: 0, max: 50, step: 0.01 },
    // 	blue: { value: 1, min: 0, max: 50, step: 0.01 },
    // 	threshold: { value: 0, min: 0, max: 1, step: 0.01 },
    // });

    const intensity = 0.3;
    const radius = 2.2;
    const threshold = 0;

    const arcPoints = useMemo(() => {
        const points = [];
        const geometry = new THREE.BufferGeometry().setFromPoints(
            new THREE.EllipseCurve(
                0,
                0,
                1.1,
                1.1,
                0,
                2 * Math.PI,
                false,
                0
            ).getPoints(128)
        );
        let positions = geometry.attributes.position;
        for (let i = 0; i < positions.count; i++) {
            let p = new THREE.Vector3().fromBufferAttribute(positions, i);
            points.push(p);
        }
        return points;
    }, []);

    return (
        <Canvas
            gl={{ antialias: false }}
            style={{
                width: '100vw',
                height: '100%',
            }}
            dpr={[1, 2]}
            perspective
            camera={{
                zoom: 1,
                position: [0, 0, 2],
                rotation: [0, 0, -Math.PI * (5 / 16)],
            }}
        >
            <color
                attach='background'
                args={['#000']}
            />

            {/* { <OrbitControls
				// enableZoom={true}
				// enablePan={false}
				rotateSpeed={1}
				autoRotate={true}
				autoRotateSpeed={0.05}
				// maxPolarAngle={0.4 * Math.PI}
				preserveDrawingBuffer={true}
				// alpha={true}
			/> }	 */}

            {/* <Effects disableGamma>
					<unrealBloomPass
					threshold={threshold}
					strength={intensity}
					radius={radius}
				/>
			</Effects> */}

            <EffectComposer
                multisampling={8}
                disableNormalPass
            >
                {/* <N8AO aoRadius={1} intensity={1} /> */}
                <Bloom
                    luminanceThreshold={0}
                    intensity={3}
                    levels={9}
                    mipmapBlur
                />
                <Noise opacity={0.04} />
                {/* <Vignette eskil={false} offset={0.1} darkness={1.1} />	 */}
            </EffectComposer>

            <Moon />
            <Sun />
            <SunFlash />
            <MoonRing />
            <Amb />

            {/* <Line points={arcPoints} position={[0,0,0.1]} color={'#aaa'} lineWidth={3} /> */}
            {/* <Line points={arcPoints2} position={[0,0,0]} color={'turquoise'} lineWidth={1} /> */}

            <Stars
                radius={500}
                depth={30}
                count={5000}
                factor={4}
                saturation={0}
                fade
                speed={2}
            />
        </Canvas>
    );
};

export default HomeScene;
